<script>
	import { getContext, onDestroy } from 'svelte'
	import { slide } from 'svelte/transition'
	import * as animateScroll from 'svelte-scrollto'
	import { styles } from '../library/scripts/styles'
	import { admin } from '../library/scripts/PhpHandler.svelte'
	import { url } from '../library/scripts/Setup.svelte'
	import { sort_rooms } from '../library/scripts/utils'
	import {
		storeBuilderPreview,
		storeData,
		storeElementID,
		storeShowTools,
		storeShowRooms,
		storeShowRoomDetail,
	} from '../library/scripts/Store.svelte'

	import Shader from '../library/ShadersAndSpinners/Shader.svelte'
	import GuestRoom from '../components/GuestHouseRoom.svelte'

	const globals = getContext('globals')
	const fsS = globals.fsS
	const isMobi = globals.mobi
	const devWidth = globals.devWidth
	const builderToolbar = globals.builderToolbar
	const builderToolbarHover = globals.builderToolbarHover

	//the folder from which to take images
	let folder

	if (!isMobi) {
		if (devWidth >= 1440) folder = '/large/'
		if (devWidth < 1440 && devWidth >= 800) folder = '/medium/'
		if (devWidth < 800) folder = '/small/'
	}

	// mobile devices
	if (isMobi) {
		if (devWidth < 1440 && devWidth >= 800) folder = '/medium/'
		else folder = '/small/'
	}

	let elementID

	//get the rooms
	let rooms = []

	//the room to show
	let roomToShow

	//show the rooms details
	let showRoomsBooking
	const stoShowRoomsDetails = storeShowRoomDetail.subscribe((value) => {
		showRoomsBooking = value
	})

	//show rooms on site
	let showRooms
	const stoShowRooms = storeShowRooms.subscribe((value) => {
		showRooms = value
	})

	let getRooms = admin({
		cmd: 'get_rooms',
	})

	getRooms.then((value) => {
		rooms = sort_rooms(value.fetch)
		sessionStorage.setItem('rooms', JSON.stringify(rooms))
	})

	let showPreview
	const stoPreview = storeBuilderPreview.subscribe((value) => {
		showPreview = value
	})

	let data

	const stoData = storeData.subscribe((value) => {
		data = value
	})

	const set_elementID = (e) => {
		storeShowTools.set(true)
		elementID = e
		storeElementID.set(e)
	}

	const show_rooms = () => {
		let sR = showRooms === true ? false : true
		storeShowRooms.set(sR)
		if (showRooms) {
			const toScroll = setTimeout(() => {
				const scrollBlock = document.getElementById('roomstitle')
				animateScroll.scrollTo({ element: scrollBlock })
				clearTimeout(toScroll)
			}, 600)
		}
	}

	const show_room = (r) => {
		roomToShow = r
		storeShowRoomDetail.set(true)
	}

	let imgPath = url + '/rooms' + folder

	onDestroy(() => {
		stoPreview
		stoData
		stoShowRooms
		stoShowRoomsDetails
	})
</script>

{#if !showPreview}
	<div
		class="content_row"
		use:styles={{ fsS, builderToolbar, builderToolbarHover }}
		on:click={() => set_elementID('rooms')}
		on:keydown={() => set_elementID('rooms')}
	>
		<div style="margin-left:20px;">*OPEN ROOMS TOOL*</div>
	</div>
{/if}
{#each data.blocks as block}
	{#if block.blockName === 'rooms'}
		<div
			style="
			background-color: {block.blockBackgroundColor};
			margin-top: {block.blockMarginTop}%;
			margin-bottom: {block.blockMarginBottom}%;
			padding: {block.blockPadding}%;
			background-image : {block.backgroundImage};
			background-size : {block.backgroundSize};
			background-repeat : {block.backgroundRepeat};
			border-top-right-radius : {block.borderTopRadius}px;
			border-top-left-radius : {block.borderTopRadius}px;
			border-bottom-right-radius : {block.borderBottomRadius}px;
			border-bottom-left-radius : {block.borderBottomRadius}px;
			border-left-width : {block.borderLeftWidth}px;
			border-left-style : {block.borderLeftStyle};
			border-left-color : {block.borderLeftColor};
			border-top-width : {block.borderTopWidth}px;
			border-top-style : {block.borderTopStyle};
			border-top-color : {block.borderTopColor};
			border-right-width : {block.borderRightWidth}px;
			border-right-style : {block.borderRightStyle};
			border-right-color : {block.borderRightColor};
			border-bottom-width : {block.borderBottomWidth}px;
			border-bottom-style : {block.borderBottomStyle};
			border-bottom-color : {block.borderBottomColor};
			box-shadow: {block.blockBoxShadowX}px {block.blockBoxShadowY}px {block.blockBoxShadowBlur}px {block.blockBoxShadowColor};
			"
		>
			<div
				id="roomstitle"
				on:click={show_rooms}
				on:keydown={show_rooms}
				style=" 
			display:flex;
			cursor:pointer;
			width:{block.blockTitleWidth}%; 
            height:{block.blockTitleHeight}px; 
            justify-content:{block.blockTitleAlignHorizontal}; 
            align-items:{block.blockTitleAlignVertical}; 
            font-family:{block.blockTitleFontFamily}; 
            color:{block.blockTitleFontColor}; 
            font-size:{block.blockTitleFontSize}; 
            font-weight:{block.blockTitleFontWeight}; 
            font-style:{block.blockTitleFontStyle}; 
            text-decoration:{block.blockTitleFontDeco}; 
            background-color:{block.blockTitleBackgroundColor}; 
            margin-top:{block.blockTitleMarginTop}%; 
            margin-bottom:{block.blockTitleMarginBottom}%; 
            padding:{block.blockTitlePadding}%; 
			box-shadow: {block.blockTitleShadowOffsetX}px {block.blockTitleShadowOffsetY}px {block.blockTitleShadowBlur}px {block.blockTitleShadowColor};
			text-shadow: {block.blockTitleTXTShadowOffsetX}px {block.blockTitleTXTShadowOffsetY}px {block.blockTitleTXTShadowBlur}px {block.blockTitleTXTShadowColor};
			"
			>
				{block.blockTitle}
			</div>

			{#await getRooms}
				....loading
			{:then rooms}
				{#if showRooms}
					<div
						transition:slide={{ duration: 500 }}
						id="rooms_container"
						style="
						display:grid;
						grid-template-columns:repeat(auto-fit,minmax(300px,1fr));
						grid-gap:2%;
						background-color:{block.roomsContainerBG}; 
						margin-top:{block.roomsContainerMT}%; 
						margin-bottom:{block.roomsContainerMB}%; 
						padding: {block.roomsConatainerP}%;
						overflow-y:scroll;
					"
					>
						{#if rooms.fetch.length > 0}
							{#each rooms.fetch as room}
								<div
									style="
									display: flex;
									flex-direction: column;
									align-items: center;
									background-color:{block.roomsBG};
									padding:{block.roomsP}%;
									margin-top:{block.roomsMT}%; 
									margin-bottom:{block.roomsMB}%;
									border: {block.roomsBW}px solid {block.roomsBC};
									border-radius:{block.roomsBRT}px {block.roomsBRT}px {block.roomsBRB}px {block.roomsBRB}px;
									box-shadow: {block.roomsSX}px {block.roomsSY}px {block.roomsSB}px {block.roomsSC};
								"
								>
									<div
										style="
											color:{block.roomsTFC};
											font-size: {block.roomsTFS};
											font-style:{block.roomsTFSTY};
											font-weight:{block.roomsTFW};
											font-family:{block.roomsTFF};
											padding:{block.roomsTP}%;
											"
									>
										Room {room[0]}
									</div>
									<div
										style="
										width:{block.roomsIMGW}%;
										box-shadow: {block.roomsIMGX}px {block.roomsIMGY}px {block.roomsIMGB}px {block.roomsIMGC};
										"
									>
										<img
											on:click={() => show_room(room[0])}
											on:keydown={() => show_room(room[0])}
											src="{imgPath}/{room[4]}"
											alt="room"
											style="
											height:100%;
											width:100%;
											"
										/>
									</div>

									<div
										style="
											color:{block.roomsDescShortFC};
											font-size: {block.roomsDescShortFS};
											font-family:{block.roomsDescShortFF};
											font-style:{block.roomsDescShortFSTY};
											font-weight:{block.roomsDescShortFW};
											padding:{block.roomsDescShortP}px;
											"
									>
										{room[1]}
									</div>

									<div
										style="
											color:{block.roomsPriceFC};
											font-family:{block.roomsPriceFF};
											font-size: {block.roomsPriceFS};
											font-style:{block.roomsPriceFSTY};
											font-weight:{block.roomsPriceFW};
											"
									>
										{room[8]}
										{room[5]} / {room[6]}
									</div>
									<div
										on:click={() => show_room(room[0])}
										on:keydown={() => show_room(room[0])}
										style="
											color:{block.roomsLinkFC};
											font-family:{block.roomsLinkFF};
											font-size: {block.roomsLinkFS};
											font-style:{block.roomsLinkFSTY};
											font-weight:{block.roomsLinkFW};
											cursor:pointer;
											"
									>
										check/book
									</div>
								</div>
							{/each}
						{:else}
							no rooms
						{/if}
					</div>
				{/if}
			{/await}
		</div>
	{/if}
{/each}

{#if showRoomsBooking}
	<Shader>
		<div slot="content">
			<GuestRoom room={roomToShow} />
		</div>
	</Shader>
{/if}

<style>
	img {
		cursor: pointer;
	}

	.content_row {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		width: 100%;
		cursor: pointer;
		font-style: italic;
		font-size: var(--fsS);
		background-color: var(--builderToolbar);
		height: 40px;
		border-bottom: 1px solid hsl(0, 0%, 50%);
	}

	.content_row:hover {
		background-color: var(--builderToolbarHover);
	}
</style>
